<app-radio [id]="paymentType" groupName="pay_method" [value]="paymentProvider" [checked]="selected"
           [attr.aria-label]="properTranslation" (change)="paymentProviderClick($event)" class="panel-head"
           cssClass="radio-container">
  <span class="label" [innerHTML]="properTranslation"><ng-content select="[label]"></ng-content> </span>
  <div class="image ms-auto">
    <img *ngIf="paymentImgUrl" [src]="paymentImgUrl" [alt]="properTranslation" aria-hidden="true" />
  </div>
</app-radio>

<ng-content></ng-content>